<script lang="ts" setup>
const props = defineProps<{
  user: Author
  followStatus?: number
  highlight?: string
}>()
</script>

<template>
  <RFlex direction="column" :title="user.name" class="myz-author">
    <RFlex align="center">
      <div class="myz-author__avatar">
        <MAvatar :id="user.id" :size="62" :src="user.avatar" link />
        <n-popover v-if="user.user_auth" trigger="hover">
          <template #trigger>
            <img
              v-if="user.user_auth"
              :src="`https://resource.mfuns.net/imgs/auth/${user.user_auth.type}.svg`"
              alt="auth"
              class="myz-author__auth-badge"
              :style="{
                width: 12,
                height: 12
              }"
            />
          </template>
          <div>{{ user.user_auth?.name }} {{ user.user_auth?.desc }}</div>
        </n-popover>
      </div>
      <m-link
        :to="`/member/${user.id}`"
        class="myz-author__name highlight"
        :style="{
          color: user.name_color
        }"
      >
        <RFlex :gap="4" direction="column" justify="space-around">
          <RFlex align="center" :gap="4">
            <span
              class="myz-author__name-text"
              v-html="highlight || user.name"
            ></span>
            <m-badge size="sm" :badges="user.badges" />
          </RFlex>
          <RText type="secondary">
            {{ user.info }}
          </RText>
          <RText type="secondary"> 粉丝数：{{ user.fans }} </RText>
        </RFlex>
      </m-link>
    </RFlex>

    <RFlex>
      <m-follow-button :id="user.id" style="flex: 1" :status="followStatus" />
      <m-message-button :id="user.id" style="flex: 1" />
    </RFlex>
  </RFlex>
</template>

<style lang="scss" scoped>
.myz-author {
  &__avatar {
    position: relative;
    flex-shrink: 0;
  }
  &__name {
    height: 100%;
    &-text {
      font-size: 16px;
      //font-weight: bold;
    }
  }
  &__auth-badge {
    position: absolute;
    background: #fff;
    border-radius: 50%;
    outline: 2px solid #fff;
    bottom: 0;
    right: 0;
    z-index: 100;
    height: 18px;
    width: 18px;
  }
}
</style>
